import React from 'react';

const TabHeader: React.FC = ({ children }) => {
  return <div className='tab-header'>{children}</div>;
};

export default TabHeader;
